import { useEffect } from 'react';
import { useIsMounted } from '@toss/react';

interface Props {
  webFormUrl: string;
}

export function SalesMapEmbed({ webFormUrl }: Props) {
  const mounted = useIsMounted();

  useEffect(() => {
    if (mounted) {
      const script = document.createElement('script');
      script.id = 'loadFormScript';
      script.src = 'https://salesmap.kr/web-form-loader-v3.js';
      script.async = true;
      script.onload = () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.SmFormSettings.loadForm();
      };
      document.body.appendChild(script);
    }
  }, [mounted]);

  return <div id="salesmap-web-form" data-web-form={webFormUrl}></div>;
}

export const SALES_MAP_EMBED_URLS = {
  도입_문의:
    'https://salesmap.kr/web-form/e5f25216-9048-4369-b19a-d7da3d0ab3cb',
  엔터프라이즈_문의:
    'https://salesmap.kr/web-form/5c3bc846-114d-436e-a3c2-6d83061b1ea3',
};
